import Vue, { CreateElement } from "vue";
import { Component, Prop, Watch } from 'vue-property-decorator';
import { BlockDTO } from '../../model/BlockDTO';
import { blockComponentsByKey } from '../../config/blocks';

@Component
export class WmsBlockRenderer extends Vue {
	@Prop() block: BlockDTO;

	@Watch('block', {immediate: true})
	blockChanged() {
		this.$store.fetchBlock(this.block.template);
	}

	get blockData() {
		return this.$store.getBlockData(this.block.template);
	}

	get blockComponent() {
		return blockComponentsByKey[this.block.template];
	}

	render(c: CreateElement) {
		if (!this.blockData) {
			return null;
		}

		return c(this.blockComponent, {
			class: this.block.cssClass,
			attrs: {
				id: this.block.cssId
			},
			props: {
				block: this.block,
				...this.blockData
			}
		});
	}
}
	
export default WmsBlockRenderer;
